import { Stack, Text, TitleGroup } from '@ekhodealer/ekho-common/rev';

import { onboardingContent, OnboardingPage } from './content';

export function CompletionPage() {
	const pageContent = onboardingContent[OnboardingPage.Completion];

	return (
		<Stack itemsSpacing='24'>
			<TitleGroup
				title={pageContent.pageTitle}
				description={pageContent.subtitle}
				level='page'
				variant='centered'
				maxWidth='640px'
			/>

			{/* Support Information */}
			<Text size='footnote' align='center'>
				Need help? Contact our support team at{' '}
				<a href='mailto:support@ekho.com'>support@ekho.com</a> or{' '}
				<a href='tel:+1-555-0123'>(555) 012-3456</a>
			</Text>
		</Stack>
	);
}
